"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _utils = require("../utils");
const useIsMobileScreen = () => {
  const [isMobile, setIsMobile] = (0, _react.useState)(undefined);
  (0, _react.useEffect)(() => {
    const resizeListener = () => {
      setIsMobile((0, _utils.isMobileScreen)());
    };
    resizeListener();
    window.addEventListener('resize', resizeListener);
    return () => window.removeEventListener('resize', resizeListener);
  }, []);
  return isMobile;
};
var _default = exports.default = useIsMobileScreen;